import { FC, ReactNode } from 'react';

import { DropdownOptionContent } from '@/shared/components/dropdowns';

interface SelectOptionContentProps {
    description?: ReactNode;
    icon: ReactNode;
    selected?: boolean;
    title: ReactNode;
}

const SelectOptionContent: FC<SelectOptionContentProps> = ({ description, icon, selected = false, title }) => {
    return <DropdownOptionContent control={icon} description={description} selected={selected} title={title} />;
};

export default SelectOptionContent;
